import { defineStore } from 'pinia'

function getIndex(item, list) {
  let index = -1

  for (let i = 0; i < list.length; i += 1) {
    if ((item.id !== undefined && item.id === list[i].id) || (item.createId !== undefined && item.createId === list[i].createId)) {
      index = i
      break
    }
  }

  return index
}

function freshState() {
  return {
    name: '',
    url: '',
    custom_path: '',
    allow_customer_create: false,
    favicon: '',
    logo: '',
    lists: [],
    attrs: {
      primary_color: '#009AD0',
      text_color: '#2C3D20',
      background_color: '#F8F8F8',
      template_id: 'default_preference_page',
      language: 'en',
      allow_email_change: true,
      unsubscribe_all: true,
      enhanced_security: false,
      remove_badge: false,
    },
  }
}

export const usePreferenceForm = defineStore('preferenceForm', {
  state: () => freshState(),
  actions: {
    setForm(form) {
      this.name = form.name
      this.logo = form.logo
      this.color = form.color
      this.url = form.url
      this.custom_path = form.custom_path
      this.allow_customer_create = form.allow_customer_create
      this.attrs = form.attrs
    },
    addList(list) {
      this.lists.push(list)
    },
    upsertList(list) {
      let index = getIndex(list, this.lists)

      if (index > -1) {
        this.lists[index] = list
      } else {
        this.lists.push(list)
      }
    },
    editList(i, list) {
      this.lists[i] = list
    },
    removeList(i) {
      let index = i

      if (typeof i === 'object') {
        index = getIndex(i, this.lists)
      }

      if (index > -1 && index < this.lists.length) {
        this.lists.splice(index, 1)
      }
    },
    moveList(fromIndex, toIndex) {
      if (fromIndex === toIndex) {
        return this.lists
      }
      const element = this.lists[fromIndex]
      this.lists.splice(fromIndex, 1)
      this.lists.splice(toIndex, 0, element)
    },
    addSeparator(label = '') {
      this.lists.push({
        type: 'separator',
        label,
        show_order: this.lists.length,
        createId: 'sep-' + Math.random().toString(36).substring(7),
      })
    },
    removeSeparator(separator) {
      const index = getIndex(separator, this.lists)
      if (index > -1) {
        this.lists.splice(index, 1)
      }
    },
    updateSeparator(index, data) {
      if (this.lists[index]?.type === 'separator') {
        Object.assign(this.lists[index], data)
      }
    },
    updateOrder() {
      for (let i = 0; i < this.lists.length; i += 1) {
        this.lists[i].show_order = i
      }
      return this.lists
    },
    clear() {
      Object.assign(this, freshState())
    },
  },
})
